


import { Link } from "react-router-dom";
import styles from "./Breadcrumb.module.css";
import PageMeta from "./PageMeta";

export default function Breadcrumb({ items = [] }) {
  if (!items.length) return null;

  return (
    <nav
      className={styles.breadcrumb}
      aria-label="Breadcrumb"
    >
      <ol className={styles.list}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li
              key={`${item.label}-${index}`}
              className={styles.item}
            >
              {isLast || !item.path ? (
                <span
                  className={styles.current}
                  aria-current="page"
                >
                  {item.label}
                </span>
              ) : (
                <>
                  <Link
                    to={item.path}
                    className={styles.link}
                  >
                    {item.label}
                  </Link>

                  <span
                    className={styles.separator}
                    aria-hidden="true"
                  >
                    ›
                  </span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}